import './main.scss';
import React, { useCallback, useState, useEffect } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import decodeToken from '../../../../utils/decode-token';
import TableHacNominated from '../../../organisms/role-retailer/table-hac-nominated/table-hac-nominated';
import TableHacActive from '../../../organisms/role-retailer/table-hac-active/table-hac-active';
import TableHacExited from "../../../organisms/role-retailer/table-hac-exited/table-hac-exited";
import {useTranslation} from "react-i18next";
import RoleRibbon from '../../../organisms/common/role-ribbon/role-ribbon';
import { getRetailerMainTabs } from '../../../organisms/common/role-ribbon/role-ribbon.config';
import { isRetailerRole } from '../../../../utils/role-utils';
import MainSectionHeader from '../../../organisms/common/main-section-header/main-section-header';
import MainTabPanel from '../../../organisms/common/main-tab-panel/main-tab-panel';

const RETAILER_TAB_ROUTES = {
  nominated: '/retailer/main/nominated',
  active: '/retailer/main/active',
  exited: '/retailer/main/exited',
};

const INITIAL_RELOAD_STATE = {
  nominated: true,
  active: true,
  exited: true,
};

function RetailerMain() {

  const { t } = useTranslation();

  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('nominated');
  const [reloadTabs, setReloadTabs] = useState(INITIAL_RELOAD_STATE);

  const reloadTab = useCallback((tab) => {
    setReloadTabs((current) => ({ ...current, [tab]: true }));
  }, []);

  const markTabLoaded = useCallback((tab) => {
    setReloadTabs((current) => ({ ...current, [tab]: false }));
  }, []);
  const handleNominatedDataLoaded = useCallback(() => {
    markTabLoaded('nominated');
  }, [markTabLoaded]);
  const handleActiveDataLoaded = useCallback(() => {
    markTabLoaded('active');
  }, [markTabLoaded]);
  const handleExitedDataLoaded = useCallback(() => {
    markTabLoaded('exited');
  }, [markTabLoaded]);

  useEffect(() => {
    if (location.pathname.includes('/active')) {
      setActiveTab('active');
      reloadTab('active');
    } else if (location.pathname.includes('/exited')) {
      setActiveTab('exited');
      reloadTab('exited');
    } else {
      setActiveTab('nominated');
      reloadTab('nominated');
    }
  }, [location.pathname, reloadTab]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    reloadTab(tab);
    navigate(RETAILER_TAB_ROUTES[tab]);
  };

  const topTabs = getRetailerMainTabs();
  const memberTabs = [
    { id: 'nominated', label: t('retailer-main-tabs-tab1') },
    { id: 'active', label: t('retailer-main-tabs-tab2') },
    { id: 'exited', label: t('common-exited') },
  ];
  const nominateButton = (
    <Link to="/retailer/nominate-hac" className="btn secondary">
      <span className="icon-plus"></span> {t('retailer-main-nominated-action')}
    </Link>
  );
  const memberSectionHeader = (
    <MainSectionHeader
      title={t('admin-main-tabs-tab1')}
      tabs={memberTabs}
      activeTab={activeTab}
      onTabClick={handleTabClick}
      tabsClassName="retailer-member-tabs"
      action={activeTab === 'nominated' ? nominateButton : null}
    />
  );

  return (
    <>
      {
        (token && isRetailerRole(role)) ? (
        <div className="App">
          <Header />
          <main>
            <RoleRibbon tabs={topTabs} navigate={navigate} translate={t} />

            <MainTabPanel active={activeTab === 'nominated'}>
              {memberSectionHeader}
              <TableHacNominated
                reload={reloadTabs.nominated}
                onDataLoaded={handleNominatedDataLoaded}
              />
            </MainTabPanel>

            <MainTabPanel active={activeTab === 'active'}>
              {memberSectionHeader}
              <TableHacActive
                reload={reloadTabs.active}
                onDataLoaded={handleActiveDataLoaded}
              />
            </MainTabPanel>

            <MainTabPanel active={activeTab === 'exited'}>
              {memberSectionHeader}
              <TableHacExited
                reload={reloadTabs.exited}
                onDataLoaded={handleExitedDataLoaded}
              />
            </MainTabPanel>
          </main>
        </div>
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

export default RetailerMain;
